import React, { Fragment, useEffect, useState } from 'react';
// import { Route } from 'react-router';
import { Route, useLocation } from 'react-router-dom';
import { useMount } from 'react-use';

import { apolloClient } from '../services/apollo';
import { toast } from 'react-toastify';
import { isLoggedIn, logout } from '../services/auth';
import { pageView, trackUser } from '../services/googleAnalytics';
import Progress from './Progress';
import { GET_CURRENT_USER } from '../graphql/GET_CURRENT_USER';

interface ILoggedInUser {
    id?: string;
    isBlocked?: boolean;
}

const ShareableRoute = ({ component: Component, ...rest }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState<ILoggedInUser>({});
    const location = useLocation();

    useMount(async () => {
        setIsLoading(true);
        const auth: any = await isLoggedIn(apolloClient);
        if (auth && auth.user && auth.user.me) {
            if (auth.user.me.isBlocked) {
                toast.error('Your account has been blocked. Please contact the administrator.', {
                    position: 'top-center',
                    autoClose: 5000
                });
                logout();
                return;
            }
            setLoggedInUser(auth.user.me);
            setIsAuthenticated(true);
            return setIsLoading(false);
        }
        setIsAuthenticated(false);
        return setIsLoading(false);
    });

    useEffect(() => {
        const checkBlockedStatus = async () => {
            if (loggedInUser && loggedInUser.id) {
                try {
                    const auth: any = await apolloClient.query({
                        query: GET_CURRENT_USER,
                        fetchPolicy: 'network-only'
                    });
                    if (auth && auth.data && auth.data.me && auth.data.me.isBlocked) {
                        logout('Your account has been blocked. Please contact the administrator.');
                        return;
                    }
                } catch (error) {
                    console.error('Error checking blocked status:', error);
                }
                trackUser(loggedInUser.id);
                pageView(location.pathname);
            }
        };
        checkBlockedStatus();
    }, [location, loggedInUser]);

    return (
        <Fragment>
            <Progress isAnimating={isLoading} />
            {!isLoading && (
                <Route {...rest} render={props => <Component {...props} user={isAuthenticated ? loggedInUser : null} />} />
            )}
        </Fragment>
    );
};

export default ShareableRoute;
